import { useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import AdminRecap from "./AdminRecap";
import AdminMonthlyRecap from "./AdminMonthlyRecap";
import { DeskMonthPanel } from "@/components/admin/DeskMonthPanel";

export default function AdminRecaps() {
  const [params, setParams] = useSearchParams();
  const tab = ["monthly", "desk"].includes(params.get("tab")) ? params.get("tab") : "weekly";
  return (
    <Tabs value={tab} onValueChange={(v) => setParams({ tab: v }, { replace: true })} data-testid="admin-recaps">
      <TabsList className="mb-6 bg-slate-100 p-1 rounded-xl">
        <TabsTrigger value="weekly" data-testid="admin-recaps-tab-weekly" className="px-4">Weekly · Discord</TabsTrigger>
        <TabsTrigger value="desk" data-testid="admin-recaps-tab-desk" className="px-4">Monthly · Discord</TabsTrigger>
        <TabsTrigger value="monthly" data-testid="admin-recaps-tab-monthly" className="px-4">Monthly · Email</TabsTrigger>
      </TabsList>
      <TabsContent value="weekly"><AdminRecap /></TabsContent>
      <TabsContent value="desk"><DeskMonthPanel /></TabsContent>
      <TabsContent value="monthly"><AdminMonthlyRecap /></TabsContent>
    </Tabs>
  );
}
